//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "flow",
  components: {},
  data() {
    return {
      // flowConfig: {
      //   bg: '#fff',
      //   padding: '15px 40px',
      //   size: '30px',
      //   numberSize: '18px',
      //   textSize: '',
      //   textTop: '30px',
      //   lineWidth: '3px',
      //   list: [
      //     {number:1, text:'创建入库单', isDone:true},
      //     {number:2, text:'入库扫码', isActive:true, isDone:false},
      //     {number:3, text:'入库结束', isDone:false},
      //   ]
      // },
    };
  },
  props: ["config"]
};
